<template>
  <section role="banner" class="contact-header-section">
    <TheSecondHead titleText="Precisa de ajuda?"
      subtitleText="Confira as perguntas mais frequentes sobre nosso serviço e tire suas dúvidas!" />
  </section>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.contact-header-section {
  text-align: center;
  padding-bottom: 16px;

  .title {
    margin-bottom: 24px;
  }

  .subtitle {
    padding: 0px 1rem;
    margin: 0 auto;
    max-width: 394px;
  }

  @media screen and (min-width: 834px) and (max-width: 1199px) {
    padding-bottom: 24px;
  }

  @media screen and (min-width: 1200px) {
    padding-bottom: 20px;

    .subtitle {
      padding: 0px;
    }
  }
}
</style>